import { Component, OnDestroy, OnInit } from '@angular/core';
import { map, Subject, take, takeUntil } from 'rxjs';
import {
  SeminarDateSeriesListModel,
  SeminarFilterOptionModel,
} from '../../../../models/seminar.model';
import { TableHeaderInterfaceModel } from '../../../../models/table.model';
import { TrainingCategoryModel } from '../../../../models/training-category.model';
import { FileManagerStateService } from '../../../../services/file-manager-state.service';
import { SeminarService } from '../../../../services/seminar.service';
import { TrainingCategoryService } from '../../../../services/training-category.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-user-library',
  templateUrl: './library.component.html',
  styleUrl: './library.component.scss',
  standalone: false,
})
export class UserLibraryComponent implements OnInit, OnDestroy {
  cardSlides: TableHeaderInterfaceModel[] = [];
  loadingLibrary: boolean = true;

  private allCategories: TrainingCategoryModel[] = [];
  selectedCategory: TrainingCategoryModel | null = null;
  seminarFilterOptions: SeminarFilterOptionModel[] = [];
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private fileManagerState: FileManagerStateService,
    private courseTypeService: TrainingCategoryService,
    private seminarService: SeminarService,
    public userService: UserService
  ) {}

  ngOnInit(): void {
    this.fetchSeminarCategories();
    this.fetchSeminarFilterOptions();
  }

  private fetchSeminarCategories(): void {
    this.courseTypeService
      .getAllTrainingCategories()
      .pipe(take(1))
      .subscribe({
        next: seminarCategories => {
          this.allCategories = seminarCategories;
          this.cardSlides = seminarCategories.map(category => ({
            title: category.name,
            details: this.fileManagerState
              .getFilesLinksCountByCategory(category.id)
              .pipe(
                takeUntil(this.destroy$),
                map(count =>
                  count == 1 ? `${count} Anhang` : `${count} Anhänge`
                )
              ),
            color50: category.color50,
            color0: category.color0,
            color70: category.color70,
            color80: category.color80,
            color90: category.color90,
          }));

          this.cardSlides.unshift({
            title: 'Alle Anhänge',
            details: this.fileManagerState.getAllFilesLinksCount().pipe(
              takeUntil(this.destroy$),
              map(count =>
                count == 1 ? `${count} Anhang` : `${count} Anhänge`
              )
            ),
            color50: '#0E332E',
            color0: '#0E332E',
            color70: '#000000',
            color80: '#E8F0EF',
            color90: '#E8F0EF',
            selected: true,
          });
        },
      });
  }

  private fetchSeminarFilterOptions(): void {
    this.seminarService
      .getSeminars(false, true)
      .pipe(take(1))
      .subscribe({
        next: (seminars: SeminarDateSeriesListModel[]) => {
          this.seminarFilterOptions = seminars.map(seminar => ({
            id: seminar.seminar.id,
            title: seminar.seminar.title,
            dates: seminar.dates,
            isDraft: seminar.seminar.isDraft,
          }));
        },
      });
  }

  onCardClicked(activeHeaderCard: TableHeaderInterfaceModel): void {
    this.cardSlides = this.cardSlides.map(slide => ({
      ...slide,
      selected: slide.title === activeHeaderCard.title,
    }));

    this.selectedCategory = this.allCategories.find(
      category => category.name === activeHeaderCard.title
    );

    this.fileManagerState.applyCategoryFilter(this.selectedCategory);
  }

  onLibraryLoaded(): void {
    this.loadingLibrary = false;
  }

  ngOnDestroy(): void {
    this.fileManagerState.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
